import React, { useState, useEffect } from 'react';
import style from "./style.module.css";

import MenuTable from '../../Components/MenuTable';
import Receipt from '../../Components/Receipt';
import LogoSilang from '../../Picture/logoSilang.png';
import { useNavigate } from 'react-router-dom';

const PengeluaranGym2 = (props) => {
  const url = props.url;
  const navigate=useNavigate("");
  const [items, setItems] = useState([]);
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem('cart');
    return savedCart ? JSON.parse(savedCart) : [];
  });
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [checkoutAktif,setCheckoutAktif]=useState(false);
  const [nilaiMetodePembayaran,setNilaiMetodePembayaran]=useState("");
  const [keteranganKirim,setKeteranganKirim]=useState("");

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    try {
      const response = await fetch(`${url}/?op=getDataInventoryGym2`);
      const data = await response.json();

      setItems(data);
    } catch (error) {
      console.error('Error fetching items:', error);
    }
  };

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  const updateCart = (name, price, quantity) => {
    setCart(prevCart => {
      const itemIndex = prevCart.findIndex(item => item.name === name);
      if (itemIndex >= 0) {
        const updatedCart = [...prevCart];
        if (quantity > 0) {
          updatedCart[itemIndex] = { ...updatedCart[itemIndex], quantity, total: price * quantity };
        } else {
          updatedCart.splice(itemIndex, 1);
        }
        return updatedCart;
      } else {
        return [...prevCart, { name, price, quantity, total: price * quantity }];
      }
    });
  };

  const handleCheckout = async () => {
 
    setCheckoutAktif(true);
    /*
    try {
      await fetch(`${url}/?op=inputPengeluaranDataInventoryGym`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(cart)
      });

      await fetch(`${url}/?op=inputHistoryPengeluaranGym`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(cart)
      });
      console.log(cart)
      setCart([]);
      fetchItems();

      setShowSuccessMessage(true); // Menampilkan pesan "Berhasil Terkirim" setelah checkout
      setTimeout(() => {
        setShowSuccessMessage(false); // Menyembunyikan pesan "Berhasil Terkirim" setelah 3 detik
      }, 3000);
    } catch (error) {
      console.error('Error during checkout:', error);
    }
      */
  };
// function klik logo silang
const KlikLogoSilang=()=>{
  setCheckoutAktif(false);
  setKeteranganKirim("");
  setNilaiMetodePembayaran("");
}
// function klik button kirim
const KlikKirim=async ()=>{
  if(nilaiMetodePembayaran!==""){
  
    try {
      await fetch(`${url}/?op=inputPengeluaranDataInventoryGym2`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(cart)
      });

      await fetch(`${url}/?op=inputHistoryPengeluaranGym2`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(cart)
      });
   
      setCart([]);
      setKeteranganKirim("");
      setCheckoutAktif(false);
      fetchItems();

      setShowSuccessMessage(true); // Menampilkan pesan "Berhasil Terkirim" setelah checkout
      setTimeout(() => {
        setShowSuccessMessage(false); // Menyembunyikan pesan "Berhasil Terkirim" setelah 3 detik
      }, 3000);
    } catch (error) {
      console.error('Error during checkout:', error);
}

}else{
  setKeteranganKirim("Silakan dipilih dahulu");
}
}
// use effect cek session
   useEffect(()=>{
       fetch(url + "/?op=cekSession", {
           credentials: "include", 
         })
         .then((response)=>response.json())
         .then((json)=>{
          
         if (json === "kosong") {
               navigate("/", { replace: true });
             }else if(json ==="gym1"){
   navigate("/gym1", { replace: true });
             }else if(json ==="owner"){
   navigate("/owner", { replace: true });
             }
         })
       },[])

  return (
    <div className={style.containerAll}>
      {checkoutAktif&&(
        <div className={style.divPembatas}></div>
      )}
    {checkoutAktif&&(
      <div className={style.containerPembayaran}>
      <div className={style.judulPembayaran}>
Metode Pembayaran
<div className={style.logoSilang}>
  <img onClick={()=>KlikLogoSilang()} src={LogoSilang}/>
</div>
        </div>
        <select value={nilaiMetodePembayaran} onChange={(e)=>{
          const value = e.target.value 
          setNilaiMetodePembayaran(value);
          setCart(cart.map((item)=>({...item,metode:value})))
          }}>
          <option value="">
            Pilih
          </option>
          <option value="Cash">
            Cash
          </option>
            <option value="Non Cash">
            Non Cash
          </option>
        </select>
        <div className={style.keteranganKirim}>{keteranganKirim}</div>
        <button onClick={()=>KlikKirim()}>
          Kirim
        </button>
      </div>
    )}
      <div className={style.divMenuTable}>
        <MenuTable items={items} updateCart={updateCart} cart={cart} />
      </div>
      <div className={style.divReceipt}>
        <Receipt cart={cart} handleCheckout={handleCheckout} />
        {/* Menampilkan pesan "Berhasil Terkirim" jika showSuccessMessage bernilai true */}
        {showSuccessMessage && <p>Berhasil Terkirim</p>}
      </div>
    </div>
  );
};

export default PengeluaranGym2;